import getParameterFromURL from './getParameterFromURL';

export function getPageUrlValue(): string {
  const config = getParameterFromURL('config');
  if (!config) return 'v1';
  if (config === 'customV2') return 'v1';
  const match = config.match(/^customV(\d+)$/);
  return match ? `v${match[1]}` : '';
}

export function determinePaymentVersion(): string {
  const everyV5 = getParameterFromURL('everydoggyV5') === 'true';
  const everyV10 = getParameterFromURL('everydoggyV10') === 'true';
  const tariff = getParameterFromURL('tariff');

  if ((everyV5 || everyV10) && tariff === 'v41') return 'p20';
  if (everyV5 && tariff === 'v43') return 'p24';
  if (everyV5 && tariff === 'v45') return 'p27';
  if (everyV5 && tariff === 'v47') return 'p29';
  if (everyV5 && tariff === 'v48') return 'p30';
  if (everyV5 && tariff === 'v49') return 'p31';
  return 'p1';
}
